import { BrokeragePlanningPerformanceBuyToMarket } from "../../BrokeragePlanningPerformanceBuyToMarket";
import { BrokeragePlanningPerformanceOrders } from "../../BrokeragePlanningPerformanceOrders";
import { BrokeragePlanningPerformanceProfit } from "../../BrokeragePlanningPerformanceProfit";
import { BrokeragePlanningPerformanceRevenue } from "../../BrokeragePlanningPerformanceRevenue";
import { DataSource, Label, Layout, Switch, Tab, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutBrokeragePlanningPerformance extends Layout {
    labelMessage: Label;
    layoutBPPerfOrders: BrokeragePlanningPerformanceOrders;
    layoutBPPerfProfit: BrokeragePlanningPerformanceProfit;
    layoutBPPerfRevenue: BrokeragePlanningPerformanceRevenue;
    layoutBrokeragePlanningPerformanceBuyToMarket: BrokeragePlanningPerformanceBuyToMarket;
    sourceBrokeragePlanningPerf: DataSource;
    switchView: Switch;
    tabBuyToMarket: Tab;
    tabOrders: Tab;
    tabProfit: Tab;
    tabRevenue: Tab;
    tabsetBPPerf: Tabset;
    textboxProfileId: Textbox;
}
